import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Career Fatal Error (F-MINIERRBG)
 *
 * Teljes képernyős hibaképernyő a career apphoz: a betöltő képernyővel
 * AZONOS brandelt háttéren (SSR preload_bg/preload_image a
 * window.__CAREER_CONFIG__.site-ból) jelenik meg az üzenet.
 *
 * SZÁNDÉKOSAN career-lokális (nem a közös FullpageError): a career.tpl nem
 * tölti be a miniapp-components webpack chunkot, ezért ide a
 * src/components-ből importálni tilos — az app némán eltörne.
 */
import React from 'react';
export function CareerFatalError({ title, message, onRetry, retryLabel }) {
    const bootSite = typeof window !== 'undefined' && window.__CAREER_CONFIG__
        ? window.__CAREER_CONFIG__.site
        : undefined;
    const preloadBg = bootSite && bootSite.preload_bg ? bootSite.preload_bg : '';
    const preloadImg = bootSite && bootSite.preload_image ? bootSite.preload_image : '';
    return (_jsx("div", { className: "career-preload career-fatal-error", style: preloadBg ? { background: preloadBg } : undefined, role: "alert", "data-testid": "career-fatal-error", children: _jsxs("div", { className: "career-fatal-error-card", children: [preloadImg ? _jsx("img", { src: preloadImg, alt: "", className: "career-preload-image" }) : null, _jsx("h2", { className: "career-fatal-error-title", children: title }), message ? _jsx("p", { className: "career-fatal-error-message", children: message }) : null, onRetry ? (_jsx("button", { type: "button", className: "career-fatal-error-retry", onClick: onRetry, children: retryLabel || 'Újrapróbálás' })) : null] }) }));
}
